// extracted by mini-css-extract-plugin
module.exports = {"Heading":"PaymentDetailsCard_Heading__1tiXU","ContentContainer":"PaymentDetailsCard_ContentContainer__14rYN","EditButtonContainer":"PaymentDetailsCard_EditButtonContainer__bFZ_C"};